import { render, staticRenderFns } from "./AddPropertyBill.vue?vue&type=template&id=0f2272e4&scoped=true&"
import script from "./AddPropertyBill.vue?vue&type=script&lang=js&"
export * from "./AddPropertyBill.vue?vue&type=script&lang=js&"
import style0 from "./AddPropertyBill.vue?vue&type=style&index=0&id=0f2272e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2272e4",
  null
  
)

export default component.exports